import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'RAAH (Redressal System)',
        projectDesc: 'This platform will help the citizens to submit their grievances and get updates transparently on District Level.',
        tags: ['ExpressJs', 'NodeJS', 'React', 'JS'],
        code: 'https://github.com/ruhuRaj/RAAH_Redressal-System',
        demo: 'https://raah-sigma.vercel.app/',
        image: one
    },
    {
        id: 2,
        projectName: 'Study Planet',
        projectDesc: 'It is Edtech Platform where you can find many courses online and then can buy it and can learn many skills.',
        tags: ['ExpressJs', 'NodeJS', 'React', 'JS'],
        code: 'https://github.com/ruhuRaj/StudyPlanet',
        demo: 'https://studyplanet-six-flame.vercel.app/',
        image: two
    },
    {
        id: 3,
        projectName: 'Ecomzy Platform',
        projectDesc: 'A Platform where you can buy Cloths, Accessories, Desktops, Rings etc.',
        tags: ['React.js', 'Javascript', 'Redux', 'TailwindCSS'],
        code: 'https://github.com/ruhuRaj/Shopping_App',
        demo: 'https://blogs-context-3qj3.vercel.app/',
        image: three
    },
    {
        id: 4,
        projectName: 'GIF Generator',
        projectDesc: 'This project involves random generator of GIFs on searching by similar names of any gifs.',
        tags: ['React', 'JS', 'TailwindCSS', 'HTML'],
        code: 'https://github.com/ruhuRaj/GIF_Generator',
        demo: 'https://gif-generator-rho-pied.vercel.app/',
        image: four
    },
    {
        id: 5,
        projectName: 'Testimonial',
        projectDesc: 'A very simple design of Testimonial Projects.',
        tags: ['React', 'JS', 'CSS', 'HTML'],
        code: 'https://github.com/ruhuRaj/Testimonial',
        demo: 'https://testimonial-gold.vercel.app/',
        image: five
    },
    {
        id: 6,
        projectName: 'Weather App',
        projectDesc: 'This project involves the prediction of weather of places.',
        tags: ['React', 'JS', 'CSS', 'HTML'],
        code: 'https://github.com/ruhuRaj/Weather_App',
        demo: 'https://ruhuraj.github.io/Weather_App/',
        image: six
    },
    {
        id: 7,
        projectName: 'Tic-Tac-Toe Game',
        projectDesc: 'Tic Tac Toe Game',
        tags: ['React', 'JS', 'CSS', 'HTML'],
        code: 'https://github.com/ruhuRaj/Tic-Tac-Toe_Game',
        demo: 'https://ruhuraj.github.io/Tic-Tac-Toe_Game/',
        image: seven
    },
    {
        id: 8,
        projectName: 'RazorPay Clone',
        projectDesc: 'This is clone of RazorPay Website.',
        tags: ['React', 'JS', 'CSS', 'HTML'],
        code: 'https://github.com/ruhuRaj/RazorPay_Clone',
        demo: 'https://ruhuraj.github.io/RazorPay_Clone/',
        image: eight
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/